import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { debug } from './utils/DebugLogger';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({

    // 後備語言 (當 localStorage 沒有記錄時才使用)
    fallbackLng: 'en',

    // 調試模式 - 在開發環境中啟用
    debug: process.env.NODE_ENV === 'development',
    
    // 插值設定
    interpolation: {
      escapeValue: false, // React 已經做了 XSS 保護
    },
    
    // 載入設定
    load: 'languageOnly',
    
    // 資源設定
    resources: undefined, // 讓 backend 處理
    
    // 後端設定
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'default',
      },
    },
    
    // 語言檢測設定
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    // 支援的語言
    supportedLngs: ['zh', 'en', 'es', 'ja', 'ko', 'fr', 'de', 'it'],
    nonExplicitSupportedLngs: true,
    
    // 命名空間
    defaultNS: 'translation',
    ns: ['translation', 'bbgClaim', 'dexPage', 'landingPage', 'profilePage', 'walletPage', 'game', 'characterCard', 'itemCard', 'shopItemCard', 'characterSynthesisPage', 'appearancePage', 'miningMapPage', 'miningNodeDetailModal', 'miningGridMap', 'activeMiningSessionCard', 'characterDispatchModal', 'characterLibrary', 'itemInventory', 'gameConstants', 'ShopPage', 'SkillConfig', 'Skills', 'Races', 'harvestResourcesModal', 'cancelMiningConfirmModal', 'sageWelcomeModal', 'initialCharacterView', 'gachaDrawModal', 'storyNarration', 'storyChapter', 'equipItemModal', 'gameGuide', 'items', 'skillAllocationConfirmModal', 'CharacterColors', 'Factions', 'throneBattlePage', 'furnacePage', 'expiredHarvestSessionCard', 'relicFusionPage', 'oauthLink', 'authCallback'],
    
    // 回退設定
    fallbackNS: ['translation'],
    
    // 載入超時設定
    react: {
      useSuspense: false,
    },
  });

// 添加錯誤處理
i18n.on('failedLoading', (lng, ns, msg) => {
  debug.error('i18n', `Failed to load ${lng}/${ns}`, msg);
});

i18n.on('loaded', (loaded) => {
  debug.success('i18n', 'Loaded resources', Object.keys(loaded));
});

i18n.on('languageChanged', (lng) => {
  debug.info('i18n', `Language changed to: ${lng}`);
});

export default i18n;
